import { InputLabel, styled } from "@mui/material";
import pxToRem from "theme/base/pxToRem";
import { DatePicker } from "@mui/x-date-pickers";

export const DatePickerField = styled(DatePicker)<{
  disabled: boolean;
  error: boolean;
}>(({ theme, disabled, error }) => ({
  "label + &": {
    marginTop: pxToRem(26),
  },
  padding: `${pxToRem(10)} ${pxToRem(12)}`,
  borderRadius: pxToRem(8),
  border: `1px solid ${theme.palette.stroke.strokeDefault}`,
  fontSize: pxToRem(16),
  lineHeight: pxToRem(16),
  fontWeight: theme.typography.fw_regular_400,
  backgroundColor: disabled
    ? theme.palette.background.bgTertiary
    : `${theme.palette.background.bgPrimary}`,
  borderColor: disabled
    ? theme.palette.background.bgTertiary
    : error
      ? theme.palette.text.textNegative
      : theme.palette.stroke.strokeDefault,

  "& input": {
    padding: 0,
  },
  "&.Mui-error": {
    borderColor: `${theme.palette.text.textNegative} !important`,
  },
  "&.Mui-disabled": {
    backgroundColor: theme.palette.background.bgTertiary,
    borderColor: theme.palette.background.bgTertiary,
  },
  "& input:-webkit-autofill": {
    "-webkit-box-shadow": `0 0 0 50px ${theme.palette.background.bgPrimary} inset`,
    "-webkit-text-fill-color": `0 0 0 50px ${theme.palette.background.bgPrimary} inset`,
  },
  "& input:-webkit-autofill:focus": {
    "-webkit-box-shadow": `0 0 0 50px ${theme.palette.background.bgPrimary} inset`,
    "-webkit-text-fill-color": `0 0 0 50px ${theme.palette.background.bgPrimary} inset`,
  },
  "&:focus-within": {
    borderColor: theme.palette.stroke.strokeBrand,
  },
  ":before": {
    display: "none",
  },
  ":after": {
    display: "none",
  },
  "& .MuiSelect-select": {
    background: "transparent !important",
    paddingTop: 0,
    paddingBottom: 0,
  },
  svg: {
    path: {
      fill: theme.palette.icon.icDefault,
    },
    marginRight: pxToRem(12),
  },
  li: {
    padding: pxToRem(16),
  },
}));

export const Label = styled(InputLabel)<{ disabled?: boolean }>(
  ({ theme, disabled = false }) => ({
    fontSize: pxToRem(16),
    lineHeight: theme.typography.lineHeight.sm,
    fontWeight: theme.typography.fw_regular_400,
    color: disabled
      ? theme.palette.text.textSecondary
      : theme.palette.text.textPrimary,
    display: "flex",
    alignItems: "center",
    transform: "none",
    gap: pxToRem(8),

    "&.Mui-focused": {
      color: disabled
        ? theme.palette.text.textSecondary
        : theme.palette.stroke.strokeBrand,
    },
  })
);
